
// const OraterCard = ({ image, name, about, from }) => {
//   return (
//     <div className="flex flex-col p-4 items-center rounded-2xl h-full">
//       <div className="border-2 border-one rounded-2xl inline-block">
//         <img
//           src={image}
//           alt="ima"
//           className="h-52 w-52 object-cover rounded-2xl m-2"
//           loading="lazy"
//         />
//       </div>
//       <h2 className="text-black font-bold text-md">{name}</h2>
//       <p className='text-one text-md font-semibold text-center line-clamp-3'>
//   {about}
// </p>


//       <p className="text-md font-semibold">{from}</p>
//     </div>
//   );
// };

// export default OraterCard;


import { Link } from "react-router-dom"; // Link is still imported in case it's used elsewhere or for future "Read More" buttons

const OraterCard = ({ image, name, about, from, link }) => {
  return (
    // Removed the <Link> wrapper for the entire card.
    // Removed cursor-pointer, hover:shadow-lg, transition-shadow.
    <div className="flex flex-col p-4 items-center rounded-2xl h-full"> {/* Reverted to a plain div */}
      <div className="border-2 border-one rounded-2xl inline-block">
        <img
          src={image}
          alt={name} // Use name for alt text for better accessibility
          className="h-52 w-52 object-cover rounded-2xl m-2"
          loading="lazy"
        />
      </div>
      {/* Container for text content to manage consistent height */}
      <div className="text-center mt-2 flex flex-col justify-between items-center flex-grow">
        <h2 className="text-black font-bold text-lg mb-1">{name}</h2>
        {/* 'about' paragraph with line-clamp and min-height for consistent space */}
        <p className='text-one text-sm font-semibold line-clamp-3 mb-1 min-h-[1.5em]'> {/* min-h for approx. 3 lines of text */}
          {about}
        </p>
        {/* 'from' paragraph */}
        <p className="text-sm font-semibold text-gray-700">
          {from}
        </p>
      </div>
    </div>
  );
};

export default OraterCard;